import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getCustomerlogins,
  updateCustomerLogins,
} from "../redux/actions/AdminAction";
import SearchIcon from "@mui/icons-material/Search";
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Container,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputAdornment,
  Paper,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import styled from "styled-components";
import { UPDATE_CUSTOMER_LOGINS_RESET } from "../Constants/Constants";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#282828",
    color: "#ffffff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#e8e9eb",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(
  id,
  created_at,
  country,
  customer_name,
  username,
  is_active
) {
  return { id, created_at, country, customer_name, username, is_active };
}

export default function ManageCustomerLogins(props) {
  const { decodedToken, checkUserPermission } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLargeScreen = useMediaQuery("(max-width:1869px)");
  const isMediumScreen = useMediaQuery("(max-width:1800px)"); // For tablet responsiveness
  const isSmallScreen = useMediaQuery("(max-width:1500px)");

  const hasAccess = (allowedRoles) => allowedRoles.includes(decodedToken?.role);

  const [row, setRow] = useState();
  const searchValue = useRef();
  const [deleteCustomerLoginId, setDeleteCustomerLoginId] = useState(null);
  const [snackOpen, setSnackOpen] = useState(false);
  const [dialogOpen, setdialogOpen] = useState(false);
  const [customerLoginData, setCustomerLoginData] = useState(null);
  const [selectedCustomerStatus, setSelectedCustomerStatus] = useState("All");
  const customerStatusFilter = ["All", "Active", "Deactive"];

  const GetAllCustomerLogins = useSelector(
    (state) => state.GetAllCustomerLogins
  );
  const { customerLoginsInfo, loading } = GetAllCustomerLogins;

  const UpdateCustomerLogins = useSelector(
    (state) => state.UpdateCustomerLogins
  );

  const { success, message, updateerror } = UpdateCustomerLogins;

  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  const [statusChangeReason, setStatusChangeReason] = useState("");
  const [statusChangeError, setStatusChangeError] = useState("");

  const handleDialogOpen = () => {
    setdialogOpen(true);
  };

  const handleDialogClose = () => {
    setdialogOpen(false);
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  const handleStatusDialogOpen = (customerId, newStatus) => {
    dispatch({ type: UPDATE_CUSTOMER_LOGINS_RESET });
    setPendingStatusChange({ customerId, newStatus });
    setStatusDialogOpen(true);
  };

  const handleStatusDialogClose = () => {
    setStatusDialogOpen(false);
    setPendingStatusChange(null);
    setStatusChangeReason("");
  };

  const handleConfirmStatusChange = () => {
    if (!pendingStatusChange.newStatus && !statusChangeReason.trim()) {
      setStatusChangeError("Reason is required for deactivation.");
      setSnackOpen(true);
      return;
    }
    if (pendingStatusChange) {
      const updated_data = {
        is_active: pendingStatusChange.newStatus,
        reason: statusChangeReason.trim(),
      };

      dispatch(
        updateCustomerLogins(pendingStatusChange.customerId, updated_data)
      );

      dispatch(getCustomerlogins());
      setStatusChangeError("");
      setSnackOpen(false);
    }
  };

  const handleisActiveSwitch = (e, cust_login_id) => {
    e.preventDefault(); // Prevent the switch from changing immediately
    const newStatus = e.target.checked;
    handleStatusDialogOpen(cust_login_id, newStatus);
    dispatch(getCustomerlogins());
  };

  const filteredCustomer = () => {
    let filteredCustomerLogin =
      (customerLoginData && JSON.parse(JSON.stringify(customerLoginData))) ||
      [];

    if (selectedCustomerStatus === "All") {
      setCustomerLoginData(customerLoginsInfo);
      const newRows =
        customerLoginsInfo &&
        customerLoginsInfo.map((value) => {
          return createData(
            value.cust_login_id,
            value.created_at,
            value.country,
            value.customer_name,
            value.username,
            value.is_active
          );
        });
      setRow(newRows);
      return;
    }

    if (selectedCustomerStatus === "Active") {
      filteredCustomerLogin = filteredCustomerLogin.filter(
        (cust) => cust.is_active == true
      );
    }

    if (selectedCustomerStatus === "Deactive") {
      filteredCustomerLogin = filteredCustomerLogin.filter(
        (cust) => cust.is_active == false
      );
    }

    const newRows =
      filteredCustomerLogin &&
      filteredCustomerLogin.map((value) => {
        return createData(
          value.cust_login_id,
          value.created_at,
          value.country,
          value.customer_name,
          value.username,
          value.is_active
        );
      });
    setRow(newRows);
  };

  useEffect(() => {
    dispatch(getCustomerlogins());
  }, [dispatch]);

  useEffect(() => {
    if (customerLoginsInfo) {
      filteredCustomer();
    }
  }, [customerLoginsInfo, selectedCustomerStatus]);

  useEffect(() => {
    if (success && statusDialogOpen) {
      handleStatusDialogClose();
      setSnackOpen(true);
    }
  }, [success, statusDialogOpen]);

  return (
    <Fragment>
      <Container>
        <Box>
          <Box sx={{ margin: 3, fontSize: 25 }}>
            Manage your customers logins
            <Divider sx={{ marginTop: 2 }}></Divider>
          </Box>
          <Grid
            sx={{
              fontSize: 25,
              margin: 3,
            }}
          >
            {checkUserPermission(105, "can_add") && (
              <Grid>
                <Button
                  type="submit"
                  size="small"
                  onClick={() => {
                    // dispatch({ type: GET_CUSTOMER });
                    navigate("/managecustomerlogins/new");
                  }}
                  sx={{
                    backgroundColor: "#282828",
                    color: "#ffffff",
                    width: "25vh",
                    borderRadius: 0,
                    fontSize: 16,
                    "&:hover": {
                      backgroundColor: "#282828",
                      color: "#ffffff",
                    },
                  }}
                >
                  Add new customer login
                </Button>
              </Grid>
            )}
            <Grid
              sx={{
                marginTop: 3,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Autocomplete
                size="medium"
                sx={{
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                }}
                options={customerStatusFilter}
                value={selectedCustomerStatus || null}
                getOptionLabel={(options) => options}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Customer Status"
                    />
                  );
                }}
                onChange={(e, values) => {
                  if (values) {
                    setSelectedCustomerStatus(values);
                  }
                }}
              />
              <TextField
                inputRef={searchValue}
                sx={{ width: "40vh" }}
                placeholder="Search"
                onChange={(e) => {
                  dispatch(getCustomerlogins(e.target.value));
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginBottom: "5%",
        }}
      >
        <TableContainer
          component={Paper}
          sx={{
            width: "55%",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Created at</StyledTableCell>
                <StyledTableCell>Country</StyledTableCell>
                <StyledTableCell>Customer Name</StyledTableCell>
                <StyledTableCell>Username</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                {/* <StyledTableCell>Edit</StyledTableCell> */}
                {/* <StyledTableCell>Delete</StyledTableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {row?.length > 0 ? (
                row.map((row, index) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell component="th" scope="row">
                      {index + 1}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {row.created_at}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {row.country}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {row.customer_name}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {row.username}
                    </StyledTableCell>

                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "100px",
                      }}
                    >
                      Off
                      <Switch
                        disabled={!checkUserPermission(105, "can_edit")}
                        checked={row.is_active}
                        onChange={(e) => handleisActiveSwitch(e, row.id)}
                      />
                      On
                    </StyledTableCell>
                    {/* <StyledTableCell
                      style={{ 
                        wordWrap: "break-word",
                        maxWidth: "500px",
                        textAlign: "left",
                      }}
                    >
                      <Button
                        sx={{
                          backgroundColor: "#ffffff",
                          border: "1px solid black",
                          color: "black",
                          fontSize: 12,
                          height: "30px",
                        }}
                        onClick={() => navigate(`/managecustomerlogins/${row.id}`)}
                      >
                        Edit
                      </Button>
                    </StyledTableCell> */}
                    {/* <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "500px",
                        textAlign: "left",
                      }}
                    >
                      <Button
                        disabled={!hasAccess(["superuser", "admin"])}
                        sx={{
                          backgroundColor: !hasAccess(["superuser", "admin"])
                            ? "#D8D9DA"
                            : "#d9534f",
                          color: "white",
                          fontSize: 12,
                          height: "30px",
                          "&:hover": {
                            backgroundColor: "#d9534f",
                            color: "white",
                          },
                        }}
                        onClick={() => {
                          setdialogOpen(true);
                          //   setDeleteCustoemrId(row.id);
                        }}
                      >
                        Delete
                      </Button>
                    </StyledTableCell> */}
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow
                  style={{
                    wordWrap: "break-word",
                    maxWidth: "100%",
                  }}
                >
                  <StyledTableCell
                    component="th"
                    colSpan={9}
                    scope="row"
                    style={{
                      textAlign: "center",
                      wordWrap: "break-word",
                      maxWidth: "100%",
                      fontSize: 15,
                    }}
                  >
                    No data found
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {success && message && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Success</AlertTitle>
              {message}
            </Alert>
          </Snackbar>
        )}
        {updateerror && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Error</AlertTitle>
              {updateerror}
            </Alert>
          </Snackbar>
        )}
        {statusChangeError && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Field Required</AlertTitle>
              {statusChangeError}
            </Alert>
          </Snackbar>
        )}
        {/* {success && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Success</AlertTitle>
              Record deleted successfully
            </Alert>
          </Snackbar>
        )}
        {error && (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={snackOpen}
            autoHideDuration={3000}
            onClose={handleSnackClose}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
          </Snackbar>
        )} */}
        {/* <Dialog
          open={dialogOpen}
          onClose={handleDialogOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Opps!</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this customer? If you delete the
              customer, their HX rules will also be deleted.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>No</Button>
            <Button
              onClick={() => {
                dispatch(deleteCustomer(deleteCustomerId)).then(() => {
                  dispatch(getCustomer());
                  setSnackOpen(true);
                  handleDialogClose();
                });
              }}
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog> */}
      </Box>
      <Dialog
        open={statusDialogOpen}
        onClose={!loading ? handleStatusDialogClose : undefined}
        aria-labelledby="status-dialog-title"
        aria-describedby="status-dialog-description"
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "80vh", // Limit dialog height
            overflow: "visible", // Prevent scroll container
          },
        }}
      >
        <DialogTitle id="status-dialog-title">
          Confirm{" "}
          {pendingStatusChange?.newStatus ? "Activation" : "Deactivation"}{" "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="status-dialog-description">
            Are you sure you want to{" "}
            {pendingStatusChange?.newStatus ? "reactivate" : "deactivate"} this
            customer login?
          </DialogContentText>
          {pendingStatusChange?.newStatus === false && (
            <TextField
              autoFocus
              margin="dense"
              id="reason"
              label="Reason for status change"
              type="text"
              fullWidth
              variant="outlined"
              value={statusChangeReason}
              onChange={(e) => setStatusChangeReason(e.target.value)}
              multiline
              rows={3}
              sx={{ mt: 2 }}
              required
              disabled={loading} // Use global loading state
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#282828",
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "#282828",
                color: "#ffffff",
              },
              "&:disabled": {
                backgroundColor: "#D8D9DA",
                color: "#9E9E9E",
              },
            }}
            onClick={handleStatusDialogClose}
            color="primary"
            disabled={loading}
          >
            Cancel
          </Button>
          <LoadingButton
            sx={{
              backgroundColor: "#282828",
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "#282828",
                color: "#ffffff",
              },
            }}
            onClick={handleConfirmStatusChange}
            variant="contained"
            loading={loading}
            // disabled={!statusChangeReason.trim()}
            loadingIndicator="Loading..."
          >
            Confirm
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
